<template>
  <div class="application review">
    <div class="questions" v-if="funding && user">
      <div class="question">
        <p class="title">Your Funding</p>

        <div class="block">
          <p class="phase">Review your proposed funding</p>
          <div class="item">
            <p>
              Date Available
              <span>{{ funding.date_available | format_date }}</span>
            </p>
          </div>
          <div class="item">
            <p>
              Funding Amount
              <span>${{ funding.funding_amount }}.00</span>
            </p>
          </div>
          <div class="item">
            <p>
              Funding Fees
              <span>
                ${{
                funding.funding_fee != "0" ? funding.funding_fee : "0.00"
                }}
              </span>
            </p>
          </div>
          <div class="item">
            <p>
              Legal Fees
              <span>
                ${{
                funding.legal_fees != "0" ? funding.legal_fees : "0.00"
                }}
              </span>
            </p>
          </div>
          <div class="item">
            <p>
              Net Funding
              <span class="large">${{ funding.net_funding }}.00</span>
            </p>
          </div>

          <div v-if="!user.funding_method" class="transfer">
            <p>Choose your transfer method below.</p>
            <div class="choices">
              <div
                class="choice"
                :class="{ chosen: method == 'wire' }"
                @click="method = 'wire'"
              >Wire ($25 fee)</div>
              <div
                class="choice"
                :class="{ chosen: method == 'ach' }"
                @click="method = 'ach'"
              >ACH (free)</div>
            </div>
          </div>
        </div>

        <p class="error-msg" v-if="error">Please choose a transfer method above.</p>
        <button v-if="!user.funding_method" @click="sendApplication()" class="btn">Accept Funding</button>
      </div>
    </div>

    <transition name="fade">
      <saving-info
        v-if="save_info_screen"
        title="Setting up your funding!"
        body="Please wait a moment while we send you instructions."
      ></saving-info>
    </transition>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
import Section from "@/components/Application/Section";
import Questions from "@/components/Application/QuestionsEdit";
import QuestionsList from "@/components/Application/Forms.json";
import SavingInfo from "@/components/Application/SavingInfo";

export default {
  name: "ReviewFunding",
  props: ["phase", "phase_name"],
  components: {
    "intro-section": Section,
    questions: Questions,
    "saving-info": SavingInfo
  },
  data() {
    return {
      method: null,
      funding: null,
      user: null,
      save_info_screen: false,
      sendEmail: functions.httpsCallable("sendEmail"),
      error: null
    };
  },
  firestore() {
    return {
      user: db.collection("user").doc(this.$store.state.user_id)
    };
  },
  created() {
    return db
      .collection("user")
      .doc(this.$store.state.user_id)
      .collection("funding")
      .doc("fund")
      .get()
      .then(doc => {
        if (doc.exists) {
          this.funding = doc.data();
        }
      });
  },
  methods: {
    async sendApplication() {
      if (this.method) {
        this.save_info_screen = true;
        await this.saveFundingApproval();
        await this.sendUserEmail();
        await this.sendAdminEmail();
        setTimeout(() => {
          this.save_info_screen = false;
        }, 5000);
      } else {
        this.error = true;
      }
    },
    saveFundingApproval() {
      return db
        .collection("user")
        .doc(this.user.id)
        .set({ funding_method: this.method }, { merge: true })
        .then(() => {});
    },
    sendUserEmail() {
      let vm = this;
      return Promise.all([
        this.sendEmail({
          template_name: "equfi-funding-approval",
          from_email: null,
          to_email: [
            {
              email: vm.$store.state.user.start.email,
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "name",
              content: vm.$store.state.user.start.full_name
            },
            {
              name: "phase",
              content: vm.phase_name
            }
          ]
        })
      ]);
    },
    sendAdminEmail() {
      let vm = this;
      return Promise.all([
        this.sendEmail({
          template_name: "equfi-funding-approved-alert",
          subject: "User Approved Funding!",
          from_email: null,
          to_email: [
            {
              email: "sam@samsonstages.com",
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "name",
              content: vm.$store.state.user.start.full_name
            },
            {
              name: "email",
              content: vm.$store.state.user.start.email
            },
            {
              name: "company",
              content: vm.$store.state.user.businessBasics.business_name
            },
            {
              name: "loan",
              content: "$" + vm.funding.funding_amount
            },
            {
              name: "application_url",
              content:
                "https://equfiloans.com/applications/" + vm.$store.state.user_id
            }
          ]
        })
      ]);
    }
  }
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.review {
  margin-top: 0;
  background: rgba(11, 110, 251, 0.08);
  .questions {
    max-width: 450px;
    width: 100%;
    margin: auto;
    margin-top: 0 !important;
    .question {
      padding: 30px;
      background: transparent;
      .title {
        margin: 0;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 25px;
      }
      .block {
        margin-bottom: 30px;
        width: 100%;
        background: white;
        padding: 20px;
        p.phase {
          margin-top: 0;
          font-size: 17px;
          border-bottom: 2px solid #2196f3;
          padding-bottom: 5px;
        }
        .item {
          padding: 8px 0;
          border-bottom: 1px solid #eaeaea;
          &:last-child {
            border-bottom: none;
          }
          p {
            position: relative;
            margin: 0;
            font-size: 14px;
            display: flex;
            font-weight: bold;
            justify-content: space-between;
            align-items: center;
            span {
              padding: 0 20px;
              font-size: 13px;
              font-weight: normal;
              text-align: right;
              &.large {
                font-size: 20px;
                color: #2196f3;
              }
            }
            .edit {
              position: absolute;
              right: -6px;
              height: 23px;
              cursor: pointer;
              padding: 5px;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  z-index: 99;
  justify-content: center;
  align-items: center;
  .offclick {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.7);
  }
  .holder {
    position: relative;
    z-index: 2;
    background: #f1f6ff;
    padding: 30px;
    width: 100%;
    max-width: 450px;
    max-height: 90%;
    height: auto;
    overflow: hidden;
    overflow-y: auto;
  }
}

.transfer {
  margin-top: 40px;
  p {
    font-size: 15px;
    opacity: 0.7;
    margin-bottom: 10px;
  }
  .choices {
    display: flex;
    flex-direction: row;
  }
  .choice {
    width: 100%;
    color: #0b6efb;
    padding: 7px 15px;
    margin-bottom: 10px;
    background-color: #eff5ff;
    border-radius: 5px;
    margin-right: 15px;
    font-size: 15px;
    cursor: pointer;
    box-shadow: 0px 2px lightgray;
    border: 2px solid transparent;
    transition: border 0.3s;
  }
  .choice.chosen {
    box-shadow: 0px 0px;
    border: 2px solid #0b6efb;
  }
}

.error-msg {
  color: red;
  font-size: 15px;
}
</style>
